import { useEffect } from 'react';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

/**
 * Initialises a PhotoSwipe lightbox with a custom caption element.
 * @param {string} galleryId — the `id` attribute of the gallery container (without `#`)
 */
export function usePhotoSwipeLightbox(galleryId) {
    useEffect(() => {
        let lightbox = new PhotoSwipeLightbox({
            gallery: '#' + galleryId,
            children: 'a',
            pswpModule: () => import('photoswipe'),
        });

        lightbox.on('uiRegister', function () {
            lightbox.pswp.ui.registerElement({
                name: 'custom-caption',
                order: 9,
                isButton: false,
                appendTo: 'root',
                html: '',
                onInit: (el, pswp) => {
                    pswp.on('change', () => {
                        const currSlideElement = pswp.currSlide.data.element;
                        let captionHTML = '';
                        if (currSlideElement) {
                            const hiddenCaption =
                                currSlideElement.querySelector('.hidden-caption-content');
                            captionHTML = hiddenCaption
                                ? hiddenCaption.innerHTML
                                : currSlideElement.querySelector('img')?.getAttribute('alt') || '';
                        }
                        el.innerHTML = captionHTML;
                    });
                },
            });
        });

        lightbox.init();

        return () => {
            lightbox.destroy();
            lightbox = null;
        };
    }, [galleryId]);
}
